import { render, staticRenderFns } from "./SolicitudFechaMatricula.vue?vue&type=template&id=10bdae92"
import script from "./SolicitudFechaMatricula.vue?vue&type=script&lang=js"
export * from "./SolicitudFechaMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports